import { createTheme } from "@mui/material/styles";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";

const PRIMARY = "#72bf44";
const SECONDARY = "#f57e20";
const ERROR = "#f44336";

const LIGHT_BODY = "#eef0f8";
const LIGHT_DRAWER_SELECTION = "#b5b5c3";
const LIGHT_SECTION_HOVER = "#f3f6f9";
const MEDIUM_GRAY = "#9e9e9e";

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: ["Titillium Web", "sans-serif "].join(","),
    useNextVariants: true,
  },
});

export const lightTheme = createTheme({
  breakpoints: theme.breakpoints,
  palette: {
    primary: { main: PRIMARY, contrastText: "#fff", disabled: "#e0e0e0" },
    secondary: { main: SECONDARY, contrastText: "#fff" },
    error: { main: ERROR, contrastText: "#fff" },
    mediumGray: MEDIUM_GRAY,
    background: {
      paper: "#fff",
      default: LIGHT_BODY,
    },
    text: {
      primary: "rgba(0, 0, 0, 0.95)",
      secondary: "rgba(0, 0, 0, 0.8)",
      disabled: "rgba(0, 0, 0, 0.75)",
      hint: "rgba(0, 0, 0, 0.68)",
    },
    drawer: {
      background: "#fff",
      active: PRIMARY,
      focus: PRIMARY,
      sectionOpen: LIGHT_SECTION_HOVER,
      iconInactive: LIGHT_DRAWER_SELECTION,
      iconActive: PRIMARY,
      iconOpen: "#455a64",
      textActive: PRIMARY,
      textOpen: "#455a64",
      textClose: "#757575",
      openDrawerInactive: LIGHT_DRAWER_SELECTION,
      openDrawerHover: PRIMARY,
      expandArrow: LIGHT_DRAWER_SELECTION,
      navSelector: PRIMARY,
    },
    header: {
      // background: "#757575",
      background: "#fff",
      title: "#424242",
      breadcrumbsBackground: LIGHT_BODY,
    },
    colorInPrimary: "#fff", //color dentro de fondo primario
    table: {
      headerBg: "#f8f8f8",
      border: "#babfc7",
      headerColor: "#181d1f",
    },
    tooltip: {
      warning: {
        bg: "#ff9800",
        color: "#fff",
      },
      info: {
        bg: "#fff",
        color: "rgba(0, 0, 0, 0.87)",
      },
    },
  },

  overrides: {
    MuiListItem: {
      button: {
        "&:hover": {
          backgroundColor: `${LIGHT_SECTION_HOVER} !important`,
        },
      },
    },
    MuiButton: {
      containedPrimary: {
        color: "white !important",
        backgroundColor: `${PRIMARY} !important`,
        "&$disabled": {
          opacity: 0.7,
        },
      },
    },
    MuiSvgIcon: {
      colorSecondary: {
        color: `${SECONDARY} !important`,
      },
      colorPrimary: {
        color: `${PRIMARY} !important`,
      },
    },
    MuiInputLabel: {
      // Name of the component ⚛️ / style sheet
      root: {
        // Name of the rule
        color: PRIMARY, // Some CSS
      },
    },
    MuiInput: {
      underline: {
        "&:before": {
          borderBottom: `1px solid ${PRIMARY}`,
        },
      },
    },
    MuiFormHelperText: {
      root: {
        error: {
          marginTop: "0.4rem !important",
        },
      },
    },
  },
  typography: theme.typography,
});

export const darkTheme = createTheme({
  breakpoints: theme.breakpoints,
  darkMode: true,
  palette: {
    mode: "dark",
    primary: { main: PRIMARY, contrastText: "#fff" },
    secondary: { main: SECONDARY, contrastText: "#fff" },
    error: { main: ERROR, contrastText: "#fff" },
    body: "#212121",
    background: {
      paper: "#212121",
      default: "#424242",
    },
    // text: {
    //   primary: "rgba(256, 256, 256, 1)",
    //   secondary: "rgba(256, 256, 256,.74)",
    //   disabled: "rgba(256, 256, 256, 0.38)",
    //   hint: "rgba(256, 256, 256, 0.38)",
    // },
    drawer: {
      background: "#424242",
      active: "#fff",
      focus: "#fff",
      sectionOpen: "rgba(0,0,0,0.2)",
      iconInactive: "rgba(256,256,256,.4)",
      iconActive: "#fff",
      textActive: "#fff",
      iconOpen: "rgba(256,256,256,.6)",
      textOpen: "rgba(256,256,256,.6)",
      textClose: "rgba(256,256,256,.4)",
      openDrawerInactive: "#b5b5c3",
      openDrawerHover: PRIMARY,
      expandArrow: "#b5b5c3",
      navSelector: PRIMARY,
    },
    header: {
      // background: "#757575",
      background: "#212121",
      title: "#fff",
      breadcrumbsBackground: "rgba(256,256,256,.4)",
    },
    // colorInPrimary: "#fff", //color dentro de fondo primario
    table: {
      headerBg: "#222628",
      border: "#68686e",
      headerColor: "#fff",
    },
    tooltip: {
      warning: {
        bg: "#ff9800",
        color: "#fff",
      },
    },
  },
  // overrides: {
  //   MuiButton: {
  //     containedPrimary: {
  //       color: "white !important",
  //       backgroundColor: `${"#fff"} !important`,
  //       "&$disabled": {
  //         opacity: 0.7,
  //       },
  //     },
  //   },
  //   MuiSvgIcon: {
  //     colorSecondary: {
  //       color: `${SECONDARY} !important`,
  //     },
  //     colorPrimary: {
  //       color: `${"#fff"} !important`,
  //     },
  //   },
  //   MuiInputLabel: {
  //     // Name of the component ⚛️ / style sheet
  //     root: {
  //       // Name of the rule
  //       color: "#fff", // Some CSS
  //     },
  //   },
  //   MuiInput: {
  //     underline: {
  //       "&:before": {
  //         borderBottom: `1px solid ${"#fff"}`,
  //       },
  //     },
  //   },
  //   MuiFormHelperText: {
  //     root: {
  //       error: {
  //         marginTop: "0.4rem !important",
  //       },
  //     },
  //   },
  //   MuiOutlinedInput: {
  //     notchedOutline: {
  //       borderColor: "rgba(256,256,256,.8) !important",
  //     },
  //   },
  // },
  typography: theme.typography,
});
